import { forwardRef } from '@chakra-ui/react'
import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps, SemanticColorSchemes } from '../../types'
import { useButtonProps } from '../../hooks/useButtonProps'

export type ButtonProps = SwashbuckleComponentProps<ChakraButtonProps> & {
  colorScheme?: SemanticColorSchemes
  children: Omit<React.ReactNode, 'null' | 'undefined'>
}

export const Button = forwardRef((props: ButtonProps, ref) => {
  const buttonProps = useButtonProps(props)

  return <ChakraButton ref={ref} {...buttonProps} />
})
